import React from 'react';
import PropTypes from 'prop-types';
import $ from 'jquery';
import {inject, observer} from 'mobx-react';
import PanelComponent from '../components/shared_components/PanelComponent';
import OverviewTableComponent from '../components/overview/overview_table/OverviewTableComponent';
import DropDown from '../semantic_select_modules/semantic/components/dropdown';
import Transition from '../semantic_select_modules/semantic/components/transition';
import SelectCustom from '../semantic_select_modules/terugkerendeElementen/form/select';
import SemanticSelectCustom from '../semantic_select_modules/terugkerendeElementen/form/semanticSelect';
import ShowProvidersComponent from '../components/overview/ShowProvidersComponent';
import OverviewFormComponent from '../components/overview/OverviewFormComponent';
import LoaderComponent from '../components/shared_components/LoaderComponent';
import InterestPaymentComparisonComponent from '../components/overview/OverviewInterestPaymentComparisonComponent';
import OverviewHeaderComponent from '../components/overview/overview_header/OverviewHeaderComponent';
import OverviewTableHeadMobileComponent from '../components/overview/overview_table/OverviewTableHeadMobileComponent';
import OverviewComparisonTextComponent from '../components/overview/OverviewComparisonTextComponent';

@observer
class OverviewContainer extends React.Component {
  componentDidMount() {
    /* Initialize semantic ui after router did mount. */
    DropDown($, window, document, undefined);
    Transition($, window, document, undefined);
    SelectCustom.init();
    SemanticSelectCustom.init();
    window.scrollTo(0, 0);
    if (this.props.OverviewData.labelInterests.length === 0) {
      this.props.OverviewData.getInterestAndSortTable();
    }
  }

  render() {
    const showLoanpartOverviewTable = true;
    const {
      overviewForm,
      labelInterests,
      overviewInterestPaymentComparisonData,
      labelInterestsLoading,
      barWidth,
      dataIsEmpty,
    } = this.props.OverviewData;
    const {
      interests,
    } = overviewInterestPaymentComparisonData;
    return (
      <div className="overview-container">
        <OverviewHeaderComponent />
        <PanelComponent
          show={showLoanpartOverviewTable}
          classNames={'row overview-container--overview-table'}
        >
          <h2>Looptijdrente overzicht</h2>
          <OverviewFormComponent />
          <OverviewTableComponent
            show={labelInterests.length > 0}
          />
          <ShowProvidersComponent
            storeData={this.props.OverviewData}
            show={labelInterests.length}
            labelInterests={labelInterests}
          />
          <LoaderComponent
            show={labelInterests.length === 0 && labelInterestsLoading}
          />
          <OverviewComparisonTextComponent
            show={!dataIsEmpty}
            {...overviewForm}
          />
          <InterestPaymentComparisonComponent
            show={
                interests.length > 3 && !dataIsEmpty
            }
            {...overviewInterestPaymentComparisonData}
            barWidth={barWidth}
          />
        </PanelComponent>
      </div>
    );
  }
}

OverviewContainer.propTypes = {
  MainData: PropTypes.shape({
    isApp: PropTypes.bool,
  }),
  OverviewData: PropTypes.shape({
    getInterestAndSortTable: PropTypes.func,
    overviewForm: PropTypes.shape({}),
    labelInterestsLoading: PropTypes.bool,
    labelInterests: PropTypes.arrayOf(PropTypes.shape({})),
    overviewInterestPaymentComparisonData: PropTypes.shape({}),
    barWidth: PropTypes.number,
  }),
};
OverviewContainer.defaultProps = {
  MainData: {
    isApp: true,
  },
  OverviewData: {
    getInterestAndSortTable: () => {
    },
    overviewForm: {},
    labelInterestsLoading: false,
    labelInterests: [],
    overviewInterestPaymentComparisonData: [],
    barWidth: 0,
  },
};
export default inject('OverviewData', 'MainData')(OverviewContainer);
